const fields = `
id
heading
slug
mainImage {
  id
  mobileImage: url(imgixParams: {fm: jpg, fit: crop, crop: focalpoint, w: 375, h: 400, auto: compress})
  responsiveImage(imgixParams: {fm: jpg, fit: crop, w: 600, auto: compress}){
    srcSet
    sizes
    src
  }
}
sections {
  heading
  background
  sectionBlocks {
    __typename
    ... on TextBlockRecord {
      id
      bodyCopy
    }
    ... on ImageBlockRecord {
      image {
        id
        responsiveImage(imgixParams: {fit:crop, w: 986, auto: compress}) {
          alt
          title
          srcSet
          width
          height
          base64
        }
      }
      roundedCorners
      caption
    }
    ... on ListPageBlockRecord {
      id
      listItems {
        id
        image {
          id
          url:url(imgixParams: {fit:crop, w: 120, auto: compress})
        }
        heading
        body
      }
    }
    ... on ImageTextBlockRecord {
      id
      text
      image {
        url:url(imgixParams: {fit:crop, w: 484, auto: compress})
        width
        height
      }
      textAlignment
      roundedCorners
    }
    ... on CardBlockRecord {
      id
      heading
      body
      cta
      ctaLink
      image {
        url:url(imgixParams: {fit:crop, w: 484, auto: compress})
        width
        height
      }
    }
    ... on CardsBlockRecord {
      id
      cards {
        id
        heading
        image {
          id
          url(imgixParams: {fit:crop, fm: jpg, h: 284})
          width
          height
        }
        body
      }
    }
    ... on CtaBlockRecord {
        buttonText
        url
    }
    ... on SlideshowBlockRecord {
      id
      slides {
        id
        heading
        image{
          url(imgixParams: {fit:crop, w: 782, auto: compress})
        }
        body
      }
    }
  }
}
`

const query = slug => `
{
  page: landingPage(filter: {slug: {eq: "${slug}"}}) {
    ${fields}
  }
} 
`

const queryAll = () => `
{
  pages: allLandingPages {
    ${fields}
  }
} 
`

module.exports = {
  query,
  queryAll,
}
